<template>
<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.49 20.806c.19.131.403.194.614.194.356 0 .706-.179.92-.509 1.785-2.768 4.77-4.421 7.983-4.421 3.205 0 6.184 1.645 7.971 4.4a1.08 1.08 0 0 0 1.534.312c.506-.353.64-1.066.3-1.591-1.428-2.202-3.475-3.826-5.813-4.695a6.563 6.563 0 0 0 2.3-5.018C18.298 5.906 15.497 3 12.054 3 8.613 3 5.812 5.906 5.812 9.478c0 2.006.884 3.803 2.27 4.992-2.376.866-4.453 2.51-5.895 4.746a1.173 1.173 0 0 0 .304 1.59zm9.565-15.513c2.224 0 4.033 1.877 4.033 4.185 0 2.307-1.809 4.184-4.033 4.184s-4.033-1.877-4.033-4.184c0-2.308 1.81-4.185 4.033-4.185z" fill="#FFB402" fill-rule="evenodd"/>
</svg>
</template>

<script>
export default {

}
</script>

<style>
svg path {
    fill: var(--color-primary);
}
</style>